module.exports = __webpack_public_path__ + "media/images/fonts/iconfont-06f450345cdaa5b282b45a0175f7ac07.svg";